import CrmSettings from '@pages/crm-settings/CrmSettings';
import RequiredCustomer from '@pages/crm-settings/pages/required-customer';

export const crmSettingsRoutes = [
  {
    path: '',
    component: CrmSettings,
    exact: true
  },
  {
    path: '/required-customer',
    component: RequiredCustomer,
    exact: true
  }
];
